import { Route, Switch } from "react-router-dom";
import ConsumoListagemPage from "./Listagem/index";

function ConsumoPages() {
  return (
    <Switch>
      <Route exact path="/financeiro/consumo" component={ConsumoListagemPage} />
    </Switch>
  );
}

export default ConsumoPages;
